import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { isNativeClient } from 'Environment/launchResource/device';
import { shouldConditionallyAddAppProtectionHeader } from 'Workspace/AppContext/appProtectionUtils';

//https://issues.citrite.net/browse/WSUI-9963
export function canHaveEmptyResources(workspaceConfiguration: WorkspaceConfiguration) {
	return (
		!isNativeClient() && shouldConditionallyAddAppProtectionHeader(workspaceConfiguration)
	);
}
